import { ReactNode } from 'react';

export const menuDefaultProps: {
  wayToDisplayChildrenByDropdown: 'hover' | 'click';
  areChildrenDisplayedByDropdown?: boolean;
  currentPageLabel?: string;
  toggleSlot?: ReactNode;
  onOpenSubMenu?: (id: string) => void;
  onCloseSubMenu?: (id: string) => void;
} = {
  wayToDisplayChildrenByDropdown: 'click',
  areChildrenDisplayedByDropdown: true,
  toggleSlot: '+',
  currentPageLabel: 'Current page',
  onOpenSubMenu: () => {},
  onCloseSubMenu: () => {},
};
